import SortBySelect from '@/modules/JobListing/components/SortBySelect/SortBySelect';
import React from 'react';

import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@material-ui/icons/KeyboardArrowUpOutlined';

import styles from './MobileFilterBar.module.scss';

type MobileFilterBarProps = {
  isFiltersOpen: boolean;
  onFiltersToggle: () => void;
  sortBy: string;
  onSortChange: (value: string) => void;
};

const MobileFilterBar = ({
  isFiltersOpen,
  onFiltersToggle,
  sortBy,
  onSortChange,
}: MobileFilterBarProps) => (
  <div className={styles.bar} data-testid="mobile-filter-bar">
    <button
      type="button"
      className={styles.filtersButton}
      onClick={onFiltersToggle}
      data-testid="mobile-filters-toggle"
    >
      <span className={styles.filterIcon} aria-hidden="true">
        <span className={styles.filterIconBar} />
        <span className={styles.filterIconBar} />
        <span className={styles.filterIconBar} />
      </span>
      <span>Filters</span>
      <span className={styles.chevron}>
        {isFiltersOpen ? <KeyboardArrowUpOutlinedIcon /> : <KeyboardArrowDownOutlinedIcon />}
      </span>
    </button>
    <SortBySelect value={sortBy} onChange={onSortChange} className={styles.sortby} />
  </div>
);

export default MobileFilterBar;
